import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#464646",
      d: "M9.994 4.37c-.288 0-.575.115-.771.334L.31 13.834c-.196.196-.311.45-.311.737 0 .599.449 1.06 1.048 1.06.288 0 .553-.116.748-.3l8.82-9.016H9.384l8.82 9.016c.184.184.449.3.748.3.599 0 1.048-.461 1.048-1.06 0-.288-.115-.541-.31-.748l-8.913-9.12a1.08 1.08 0 0 0-.783-.333"
    }, null, -1)
  ])))
}
export default { render: render }